import { Box, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import React from "react";
import { DATE_FORMAT, parseDateForPicker } from "../../utils";
import { ITheme } from "../../utils/theme";

interface IDateFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
  error?: JSX.Element | string;
}

export const DateField: React.FC<IDateFieldProps> = ({
  label,
  value,
  onChange,
  onBlur,
  required = false,
  error = ''
}) => (
  <Box>
    <Typography variant="form-label" sx={{ fontWeight: 'normal' }}>
      {label}
      {required && <Typography component="span" sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}>*</Typography>}
    </Typography>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        slotProps={{
          textField: {
            error: !!error,
            onBlur: onBlur,
          },
        }}
        format={DATE_FORMAT}
        value={parseDateForPicker(value)}
        onChange={(date: Dayjs | null) => {
          if (date) {
            const formattedDate = date.format(DATE_FORMAT);
            onChange(formattedDate);
          }
        }}
      />
    </LocalizationProvider>
  </Box>
);
